import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeadingComponent from "../../../components/HeadingComponent";
import "./index.css";
import { Tabs } from "antd";
import UserInvoices from "./UserInvoices";
import UserSubscriptions from "./UserSubscriptions";
import UserVouchers from "./UserVouchers";

const UserDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user || null;

  const handleBackButtonClick = useCallback(() => {
    navigate(`/users`);
  }, []);

  const onChange = (key) => {};

  const items = [
    {
      key: "user-invoices",
      label: "Invoices",
      children: <UserInvoices user={user} />,
    },
    {
      key: "user-subscriptions",
      label: "Subscriptions",
      children: <UserSubscriptions user_id={user?.id || null} />,
    },
    {
      key: "user-vouchers",
      label: "Vouchers",
      children: <UserVouchers user_id={user?.id || null} />,
    },
  ];

  return (
    <>
      <div className="userDetailsHeader">
        <button className="backBtn" onClick={handleBackButtonClick}>
          <i className="fa-solid fa-arrow-left"></i>
          Back
        </button>
        <HeadingComponent text={`${user?.name || "User Details"} `} />
      </div>

      <Tabs
        defaultActiveKey="user-invoices"
        items={items}
        onChange={onChange}
      />
    </>
  );
};

export default UserDetails;
